import { ReactNode, forwardRef } from 'react'

import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material'

export const StyledTooltip = styled(
  forwardRef(({ className, ...props }: TooltipProps, ref) => (
    <Tooltip ref={ref} {...props} classes={{ popper: className }} />
  ))
)(() => ({
  fontWeight: 'bold',
  paddingRight: '2px',
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#6f6c6c',
    boxShadow: '10px 10px 25px -5px #a1a1a1, 4px 4px 10px -6px #a1a1a1;',
  },
}))

export const TooltipSelf = styled('span')`
  display: inline-flex;
  align-items: center;
`

export const TooltipContent = styled('span')`
  display: inline-block;
  font-weight: 700;
  font-size: 12px;
  padding: 0 8px 0 8px;
  overflow-wrap: anywhere; /* 防止超长英文导致的溢出 */
`

export type TooltipPropsType = { self: ReactNode; content: ReactNode }
